import React from "react";
import './NotificationBox.css'

interface Notification {
  title: string;
  body: string;
  image?: string; // Optional image property
}

function NotificationBox({ notification }: { notification: Notification }): JSX.Element {
  return (
    <>
      <div id="notificationHeader">
        {/* Optional image */}
        {notification.image && (
          <div id="imageContainer">
            <img src={notification.image} width={100} alt={notification.title} />
          </div>
        )}
        <span>{notification.title}</span>
      </div>
      <div id="notificationBody">{notification.body}</div>
    </>
  );
}

export default NotificationBox;
